import type { DayData } from 'voyager';
import type { CalendarAvailability } from '@features/rooms/types';

export const toDayDataMap = (availability: CalendarAvailability[]): Map<string, DayData> => {
  const map = new Map<string, DayData>();
  for (const day of availability) {
    map.set(day.date, {
      date: day.date,
      type: day.type,
      price: day.price?.amount,
      currencyCode: day.price?.currency_code,
      minimumStay: day.minimum_stay,
    });
  }
  return map;
};
